"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AutocompleteDebounce = _interopRequireDefault(require("./AutocompleteDebounce"));

var _excluded = ["field", "form", "fetchOptions"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SimpleAutocompleteDebounce = function SimpleAutocompleteDebounce(_ref) {
  var field = _ref.field,
      form = _ref.form,
      fetchOptions = _ref.fetchOptions,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_AutocompleteDebounce["default"], _extends({
    fetchOptions: fetchOptions,
    getOptionLabel: getSimpleOptionLabel,
    getOptionSelected: getSimpleOptionSelected,
    renderOption: renderSimpleOption,
    field: field,
    form: form
  }, props));
};

var _default = SimpleAutocompleteDebounce; //----- Simple Autocomplete

exports["default"] = _default;

var getSimpleOptionSelected = function getSimpleOptionSelected(option, value) {
  return option.label === value.label;
};

var getSimpleOptionLabel = function getSimpleOptionLabel(option) {
  return option && !Array.isArray(option) ? option.label : "";
};

var renderSimpleOption = function renderSimpleOption(option) {
  return option && /*#__PURE__*/_react["default"].createElement("div", null, option.label, /*#__PURE__*/_react["default"].createElement("sup", null, "[", option.value, "]"), " ") || "";
}; //----- Simple Autocomplete


SimpleAutocompleteDebounce.propTypes = {
  /**
   * The label content.
   */
  label: _propTypes["default"].string,

  /**
   * Formik field
   */
  field: _propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].any
  }).isRequired,

  /**
   * Formik form
   */
  form: _propTypes["default"].shape({
    touched: _propTypes["default"].object,
    errors: _propTypes["default"].object,
    setFieldValue: _propTypes["default"].func.isRequired
  }).isRequired,
  fetchOptions: _propTypes["default"].func.isRequired
};